import { ReactNode } from 'react'

import { TFunction } from 'i18next'

export const getDiscountValueForShow = (
	t: TFunction<'translation', 'price'>,
	price: number,
	discountPrice: ReactNode,
	discountPercent: ReactNode
) => {
	if (price <= 100) {
		return `-${discountPercent}%`
	}

	return `-${t('base', { value: discountPrice })} (${discountPercent}%)`
}
